import { createSlice } from '@reduxjs/toolkit';
export const inAppHelpSliceName = 'inAppHelp';
export const inAppHelpInitialState = {
  shouldShowHelpInToolbar: true
};
export const {
  reducer: inAppHelpReducer,
  actions: inAppHelpActions
} = createSlice({
  name: inAppHelpSliceName,
  initialState: inAppHelpInitialState,
  reducers: {
    setShouldShowHelpInToolbar: (state, action) => {
      state.shouldShowHelpInToolbar = action.payload;
    }
  }
});